// import { errorWhileLogin } from "../../../../common/components/enum";

const initialState = {
    errorWhileLogin:"",
    errorMessage:""    
};

const ssoLoginReducer = (state=initialState , action) => {
    switch(action.type)
    {
        case "sso":
            return action.payload;
        default :
            return initialState;
    }
}
export default ssoLoginReducer;
